import React, {useEffect, useState} from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import "assets/css/Settings/settings.css"
import {
  BsPerson,
  BsPersonBadge,
  BsHourglass,
  BsQuestionCircle,
  BsShieldLock,
  BsFillBinocularsFill, BsAlarm,BsFileEarmarkText
} from 'react-icons/bs';
import MyProfile from 'components/Settings/MyProfile';
import NewPassword from 'components/Settings/NewPassword';
import MyBusiness from 'components/Settings/MyBusiness';
import FAQs from 'components/Settings/FAQs';
import OperationalHours from 'components/Settings/OperationalHours';
import {useDispatch, useSelector} from "react-redux";
import {myBusinessData} from "../Redux/Settings/myBusiness/actions";
import {store} from "../Redux/store";
import {checkTokenExpiration} from "../components/functions/tokenUtils";
import Billing from "../components/Settings/Billing&Reports/Billing";
import Notifications from "../components/Settings/Notifications";
import Script from "../components/Settings/Script"


export default function Settings() {

  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(0);
  const [workingHoursData, setWorkingHoursData] = useState(null);
  const [faqData, setFaqData] = useState([]);
  const businessData = useSelector(state => state.myBusinessReducer.data)
  const user = useSelector(state => state.authReducer.data)
  const tokenTime = store.getState().authReducer?.tokens?.access?.expires;
  let data = useSelector(state => state.inboundReducer.MessageDetails)

  useEffect(() => {
    checkTokenExpiration(tokenTime);
  }, []);
  const handleFAQData = (formattedFAQData) => {
      setFaqData(formattedFAQData);
    };

  useEffect(() => {
    if (businessData === null || user?.accountID ) {
      myBusinessData(dispatch, user?.accountID)
    }
  }, [user?.accountID]);

  const handleWorkingHoursData = (workingHours) => {
    setWorkingHoursData(workingHours);
  };

  return (
    <Container fluid>
      <Row className="mt-3 m-0 p-0">
        <Col md={3} className="custom-Column-inbound-1 ">
          <h4 className="main-h4-tag-large">Settings</h4>
          <div className="mt-5">
            <p
              className={`custom-style-settings-menu mb-2 p-1 ${
                activeIndex === 0 ? "active" : ""
              }`}
              onClick={() => setActiveIndex(0)}
            >
              <BsPerson size={17} className="mr-2" />
              My Profile
            </p>
            <p
              className={`custom-style-settings-menu mb-2 p-1 ${
                activeIndex === 1 ? "active" : ""
              }`}
              onClick={() => setActiveIndex(1)}
            >
              <BsShieldLock size={17} className="mr-2" />
              Password
            </p>
            <p
              className={`custom-style-settings-menu mb-2 p-1 ${
                activeIndex === 2 ? "active" : ""
              }`}
              onClick={() => setActiveIndex(2)}
            >
              <BsPersonBadge size={17} className="mr-2" />
              My Business
            </p>

            <p
              className={`custom-style-settings-menu mb-2 p-1 ${
                activeIndex === 3 ? "active" : ""
              }`}
              onClick={() => setActiveIndex(3)}
            >
              <BsHourglass size={17} className="mr-2" />
              Operational Hours
            </p>
            <p
              className={`custom-style-settings-menu mb-2 p-1 ${
                activeIndex === 4 ? "active" : ""
              }`}
              onClick={() => setActiveIndex(4)}
            >
              <BsQuestionCircle size={17} className="mr-2" />
              FAQs
            </p>
            <p
              className={`custom-style-settings-menu mb-2 p-1 ${
                activeIndex === 5 ? "active" : ""
              }`}
              onClick={() => setActiveIndex(5)}
            >
              <BsFillBinocularsFill size={17} className="mr-2" />
              Billing & Reports
            </p>
            <p
              className={`custom-style-settings-menu mb-2 p-1 ${
                activeIndex === 6 ? "active" : ""
              }`}
              onClick={() => setActiveIndex(6)}
            >
              <BsAlarm size={17} className="mr-2" />
              Notifications
            </p>
            <p
              className={`custom-style-settings-menu mb-2 p-1 ${
                activeIndex === 7 ? "active" : ""
              }`}
              onClick={() => setActiveIndex(7)}
            >
              <BsFileEarmarkText size={17} className="mr-2" />
              Script
            </p>
          </div>
        </Col>
        <Col className="mt-5">
          <Row>
            <Col>
              {activeIndex === 0 && <MyProfile />}
              {activeIndex === 1 && <NewPassword />}
              {activeIndex === 2 && <MyBusiness />}
              {activeIndex === 3 && (
                <OperationalHours onDataUpdate={handleWorkingHoursData} />
              )}
              {activeIndex === 4 && <FAQs onFAQDataUpdate={handleFAQData} />}
              {activeIndex === 5 && <Billing />}
              {activeIndex === 6 && <Notifications />}
              {activeIndex === 7 && <Script />}
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}


